import React from 'react';

import { Erro } from 'Interface/Requisicao';

export function recuperarMensagemDeErro(erros: {
  [campo: string]: { [erro: string]: string };
}): string {
  let mensagem = '';

  Object.keys(erros).forEach((campo) => {
    Object.keys(erros[campo]).forEach((erro) => {
      mensagem = erros[campo][erro];
    });
  });

  return mensagem;
}

/**
 * Retorna os erros em formato de lista HTML
 * usando a tag UL e LI
 *
 * @param {Erro} erros Erro retornado pelo servidor
 * @returns {React.ReactElement}
 */
export function errosParaLista(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  erros: Erro
): React.ReactElement {
  const mensagens: React.ReactElement[] = [];

  if (erros.data.errors) {
    Object.keys(erros.data.errors).forEach((campo) => {
      Object.keys(erros.data.errors[campo]).forEach((erro) => {
        mensagens.push(<li>{erros.data.errors[campo][erro]}</li>);
      });
    });
  }

  return (
    <React.Fragment>
      {erros.data.message && (
        <p className="mb-0">{erros.data.message}</p>
      )}
      {mensagens && (
        <ul className={`mb-0 ${erros.data.message && 'mt-3'}`}>
          {mensagens}
        </ul>
      )}
    </React.Fragment>
  )
}

export function base64ParaArquivo(dataurl: string, filename: string) {
  const arr = dataurl.split(',');

  const mime = arr[0].match(/:(.*?);/)[1];

  const bstr = atob(arr[1]);

  let n = bstr.length;

  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

/**
 * Mapeia os dados para um novo formato preparados para os gráficos
 *
 * @param dados Dados a serem mapeados para o novo formado
 * @param eixoX Nome do campo a ser mapeado para o eixo X
 * @param eixoY Nome do campo a ser mapeado para o eixo Y
 * @param nomeDoEixoX Nome do eixo X. Valor padrão é "x"
 * @param nomeDoEixoY Nome do eixo Y. Valor padrão é "y"
 * @returns
 */
export function mapearParaGraficos(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dados: Array<any>,
  eixoX: string,
  eixoY: string,
  nomeDoEixoX = 'x',
  nomeDoEixoY = 'y'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Array<any> {
  const dadosMapeados: Array<{ [eixo: string]: string | number }> = [];

  dados.map((dado) =>
    dadosMapeados.push({
      [nomeDoEixoX]: dado[eixoX],
      [nomeDoEixoY]: dado[eixoY],
    })
  );

  return dadosMapeados;
}
